import { Nullable } from '@models/EquipmentInventory.model';

export function parseDate(s: Nullable<string>): Nullable<Date> {
  if (s === null) return s;
  return new Date(Date.parse(s));
}
